import React from 'react';
import BzmIcon from '../../../../../components/icons/BzmIcon';
import styles from './BootingIcon.module.css';
import clsx from 'clsx';
import { BootingValueVariant } from './BootingValue';

interface BootingIconProps {
  variant: BootingValueVariant;
}

export const getVariantDefinition = (
  variant: BootingValueVariant,
): {
  color: string;
  icon: string;
} => {
  switch (variant) {
    case 'transactions':
      return {
        color: '#7637FF',
        icon: 'icon-bzm-list',
      };
    case 'ssl':
      return {
        color: '#4158C5',
        icon: 'icon-bzm-lock',
      };
    case 'thinkTime':
      return {
        color: '#BC8300',
        icon: 'icon-bzm-duration',
      };
    case 'noMatchingBehaviour':
      return {
        color: '#0D6309',
        icon: 'icon-bzm-ct-mock-service',
      };
    case 'blazeData':
      return {
        color: '#656160',
        icon: 'icon-bzm-ct-data',
      };
    default:
      return {
        color: 'gray',
        icon: '',
      };
  }
};

const BootingIcon = ({ variant }: BootingIconProps) => {
  //Get color and icon based on the variant
  const definition = getVariantDefinition(variant);

  return (
    <div className={clsx(styles.circle, 'd-inline-block', 'text-center')}>
      <BzmIcon color={definition.color} variant={definition.icon} />
    </div>
  );
};

export default BootingIcon;
